import { getCookie, appName } from '@/utils/helpers';
import {
  getAdmins,
  createAdmin,
  deleteAdmin,
  getAdminByUsername,
} from '@/api';

const localState = {
  admins: [],
  currentAdmin: { username: '', isSuper: false, canEdit: false },
};

const getters = {
  // 普通权限
  currentAdminUsername: state => state.currentAdmin.username,
  // 管理员权限
  currentAdminIsSuper: state => state.currentAdmin.isSuper,
  // 普通账号管理权限
  currentAdminCanEdit: (state) => {
    return state.currentAdmin.isSuper || state.currentAdmin.canEdit;
  },
  // 系统权限
  currentAdminIsSystem: (state) => {
    return (state.currentAdmin.isSuper
      && state.currentAdmin.username === `superadmin${appName}`);
  },
  // 伪造状态
  fakeState: (state) => {
    return !state.currentAdmin.isSuper && !state.currentAdmin.canEdit;
  },
};

const actions = {
  async initAdmins({ commit }) {
    const res = await getAdmins();
    const admins = res && res.data && res.data.admins;
    commit('setAdmins', { admins });
  },
  async checkCurrentAdminPermission({ state, commit }) {
    // 管理员就不需要执行后续逻辑，因为权限是全的
    if (state.currentAdmin.isSuper) return;

    try {
      const res = await getAdminByUsername({ username: state.currentAdmin.username });
      if (res.data.code === 0) {
        const { admin } = res.data;
        commit('updateCurrentAdminPermission', admin);
      } else {
        Promise.reject(new Error(res.data.msg));
      }
    } catch (err) {
      Promise.reject(err);
    }
  },
  async createAdmin({ state, commit }, { username, password }) {
    try {
      const res = await createAdmin({ username, password });
      if (res.data.code === 0) {
        const { admin } = res.data;
        const admins = [...state.admins, admin];
        commit('setAdmins', { admins });
      } else {
        Promise.reject(new Error(res.data.msg));
      }
    } catch (err) {
      Promise.reject(err);
    }
  },
  async deleteAdmin({ state, commit }, { adminId }) {
    try {
      const res = await deleteAdmin({ id: adminId });
      if (res.data.code === 0) {
        const admins = state.admins.filter(admin => admin.id !== adminId);
        commit('setAdmins', { admins });
      } else {
        Promise.reject(new Error(res.data.msg));
      }
    } catch (err) {
      Promise.reject(err);
    }
  },
};

const mutations = {
  setAdmins(state, { admins }) {
    state.admins = admins;
  },
  setCurrentAdmin(state) {
    const username = decodeURIComponent(getCookie('username'));
    const isSuper = getCookie('isSuper') === 'true';
    const canEdit = getCookie('canEdit') === 'true';

    if (username) {
      state.currentAdmin = { username, isSuper, canEdit };
    }
  },
  updateCurrentAdminPermission(state, admin) {
    document.cookie = `canEdit=${admin.canEdit}`;
    // FIXME state.currentAdmin 初始化时为undefined
    if (state.currentAdmin) {
      state.currentAdmin.canEdit = admin.canEdit;
    }
  },
};

export default {
  getters,
  actions,
  mutations,
  state: localState,
  namespaced: true,
};

